import { Injectable } from '@angular/core';
import { CusHttp } from '../../core/services/CusHttp';
import { URLSearchParams } from "@angular/http";
// 定义接口
// 请求岗位详情
const JOBDETAILURL = 'v1/position/';
//企业信息详情
const COMPANYHURL = "v1/company/";
//推荐岗位
const RECOMMENDJOBURL = 'v1/position/hot-rec?type=rec&num=5';
// 学生收藏或取消岗位接口   v1/position-collect/collect    student_id  position_id  type 1收藏岗位
const POSTSTUFAVORJOB = 'v1/position-collect/collect';
// 检查岗位是否被收藏接口 v1/position-collect/check?position_id=6&student_id=1
const CHECKJOBFACORURL = 'v1/position-collect/check';
// 简历投递接口
const POSTRESUMEDATA = 'v1/resume-delivery/delivery';
//岗位浏览量次数增加接口
const POSTBROWSES = 'v1/position/browses';
// 检查检查学生是否投递过这个岗位 v1/resume-delivery/check?position_id=6&resume_id=1

const GETJOBCHECK_URL = 'v1/resume-delivery/check';

@Injectable()
export class DetailService {

  constructor(
    public _http: CusHttp,
  ) { }
  getJobDetailData(id: number) { // 请求岗位详情
    console.log('id', id);
    let url = JOBDETAILURL + `${id}?expand=company,positionIndustry,province,area,citys,salary,postType,education`;
    return this._http.get(url);
  }
  getCompanyDatailData(id: string) { //企业信息详情
    let url = COMPANYHURL + `${id}?fields=&expand=industry,province,area,cityss,scale,nature`;
    return this._http.get(url);
  }
  //推荐岗位
  getRecommendData() {
    return this._http.get(RECOMMENDJOBURL);
  }
  // 检查岗位是否被收藏接口 v1/position-collect/check?position_id=6&student_id=1
  getCheckJobFavor(student_id: number, position_id: number) {
    let url = CHECKJOBFACORURL + `?student_id=${student_id}&position_id=${position_id}`;
    return this._http.get(url);
  }


  // 学生收藏或取消岗位接口   v1/position-collect/collect    student_id  position_id  type 1收藏岗位
  // const POSTSTUFAVORJOB = 'v1/position-collect/collect';
  postFavorJob(obj: any) {
    let params = new URLSearchParams();
    for (let option in obj) { params.append(option, obj[option]) }
    let url = POSTSTUFAVORJOB;
    return this._http.post(url, params);
  }
  // 简历投递接口
  postStuResumeData(obj: Object) {
    let params = new URLSearchParams();
    for (let option in obj) { params.append(option, obj[option]) }
    let url = POSTRESUMEDATA;
    return this._http.post(url, params);
  }
  //岗位浏览量次数增加接口
  // const POSTBROWSES = 'v1/position/browses';
  postBrowsesData(did: any) {
    let params = new URLSearchParams();
    params.append('id', did);
    let url = POSTBROWSES;
    return this._http.post(url, params.toString());
  }
  // 检查检查学生是否投递过这个岗位 v1/resume-delivery/check?position_id=6&resume_id=1
  getJobCheck(position_id: any, resume_id: any) {
    let url = GETJOBCHECK_URL + `?position_id=${position_id}&resume_id=${resume_id}`;
    return this._http.get(url);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/detail/detail.service.ts